import styled from 'styled-components';

export const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  padding: 1.5rem;

  gap: 0.5rem;
`;

export const CategoryItem = styled.div`
  display: flex;

  gap: 1rem;
  padding: 0.5rem 0 0.5rem 0;

  justify-content: space-between;
  align-items: center;

  cursor: pointer;
`;

export const CategoryText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CategoryTitle = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.blue6};
`;

export const CategorySubtitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
